import styled from '@emotion/styled'

const LayoutContainer = styled.div`
  width: 100%;
  margin: 0 auto;
`

const PageContainer = styled.div<{ fullWidth: boolean }>`
  display: flex;
  width: 100%;
  padding: 0 0.4rem;
  margin: 0 auto;
  /* border-right: 1px solid red; */
  flex-direction: column;
  @media (min-width: 768px) {
    width: ${(props) => (props.fullWidth ? '100%' : '95vw')};
    margin: 0 auto;
  }
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media (min-width: 1300px) {
    height: 100%;
    width: ${(props) => (props.fullWidth ? '100vw' : 'calc(95vw + 41px)')};
    max-width: ${(props) => (props.fullWidth ? '100vw' : '1481px')};
    display: flex;
    background-color: white;
    /* flex-direction: column; */
  }
  @media (max-width: 390px) {
    /* align-items: center; */
    padding: ${(props) => (props.clearPadding ? '0px' : '0 0px')};
  }
`
export { LayoutContainer, PageContainer }
